import { CheckCircle2 } from 'lucide-react'

const features = [
  'Over 15 years of payment industry expertise',
  'Deep knowledge of EMV, NFC, and payment scheme requirements',
  'End-to-end support from design to certification',
  'Specialized expertise in L3 Transit, kernel, and TMS development',
  'Proven track record of successful certification projects',
  'Customer-focused approach with global industry experience',
]

export default function Company() {
  return (
    <section id="company" className="scroll-mt-20 bg-white py-14 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Desktop: image with overlay cards */}
        <div className="relative hidden overflow-hidden rounded-3xl md:block">
          <img
            src="/meeting.png"
            alt="Team meeting"
            className="h-full w-full object-cover"
            style={{ minHeight: '600px' }}
          />

          {/* Top-left card */}
          <div className="absolute left-8 top-8 max-w-xs rounded-2xl bg-gradient-to-br from-indigo-600 to-indigo-800 px-7 py-6 shadow-lg">
            <span className="inline-block rounded-full bg-white/20 px-3 py-1 text-xs font-medium text-white">
              Why Choose Us
            </span>
            <h2 className="mt-3 text-xl font-bold leading-tight text-white">
              Transforming payment innovation into certified, market-ready solutions.
            </h2>
          </div>

          {/* Bottom: 6 feature points */}
          <div className="absolute bottom-8 left-8 right-8 rounded-2xl bg-gray-900/70 px-8 py-6 backdrop-blur-sm">
            <div className="grid grid-cols-3 gap-x-8 gap-y-4">
              {features.map((f) => (
                <div key={f} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-indigo-300" />
                  <span className="text-sm leading-snug text-white/90">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile: stacked layout */}
        <div className="space-y-4 md:hidden">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="/meeting.png"
              alt="Team meeting"
              className="h-56 w-full object-cover"
            />
          </div>

          <div className="rounded-2xl bg-gradient-to-br from-indigo-600 to-indigo-800 px-6 py-6">
            <span className="inline-block rounded-full bg-white/20 px-3 py-1 text-xs font-medium text-white">
              Why Choose Us
            </span>
            <h2 className="mt-3 text-2xl font-bold leading-tight text-white">
              Transforming payment innovation into certified, market-ready solutions.
            </h2>
          </div>

          <div className="rounded-2xl bg-gray-900 px-6 py-6">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {features.map((f) => (
                <div key={f} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-indigo-300" />
                  <span className="text-sm leading-snug text-white/90">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}
